"use strict";

export default {
  width: 960,
  height: 500,
  margins: {top: 80, right: 100, bottom: 80, left: 100}
}
